export default __webpack_public_path__ + "static/media/arrow_red_select.cad1e133.svg";